import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/hr/employees',
}).lazy(() => import('./index.lazy').then((d) => d.Route))
